import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { State } from 'app/e-form/model/eform-type';
import { EFormHelper } from 'app/e-form/helper/script/helper';
import { TranslateService } from '@ngx-translate/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChoiceLookupComponent } from 'app/e-form/dialog/choice-lookup/choice-lookup.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ValidationErrors } from '@angular/forms';
import { ValidatorConfigure } from '../../../config/validator';
import { ChoiceSetupComponent } from 'app/e-form/dialog/choice-setup/choice-setup.component';
import { NewControls } from 'app/e-form/config/new-controls';
import { Observable } from 'rxjs';
@Component({
   selector: 'app-choice-properties',
   templateUrl: './choice-properties.component.html',
   styleUrls: ['./choice-properties.component.scss']
})
export class ChoicePropertiesComponent implements OnInit {
   @Input() eForm: FormGroup;
   @Input() state: State;
   @Input() table: State;

   @Output() sendFocus = new EventEmitter<boolean>();
   helper = new EFormHelper();
   newControl: NewControls;
   validators = new ValidatorConfigure();
   displayDisabled: boolean;
   @Input() eventsStateChild: Observable<void>;
   constructor(public translate: TranslateService, private fb: FormBuilder, private dialog: MatDialog) { }

   ngOnInit(): void {
      this.newControl = new NewControls(this.fb, this.eForm);
      this.helper.checkDisplayDisabled(this.eForm, this.state, this.table);
      this.helper.displayDisabledChanges.subscribe((value) => {
         this.displayDisabled = value;
      });
      this.eventsStateChild.subscribe(() => {
         this.helper.checkDisplayDisabled(this.eForm, this.state, this.table);
      });
   }

   getErrors(): Boolean {
      if (!this.getChoices) {
         return false;
      }
      let _result = false;
      Object.keys(this.getChoices.controls).forEach(key1 => {
         const _tmp = this.getChoices.get(key1) as FormGroup;
         Object.keys(_tmp.controls).forEach(key2 => {
            const controlErrors: ValidationErrors | null = _tmp.get(key2)?.errors ?? null;
            if (controlErrors) {
               _result = true;
               return;
            }
         });
      });
      return _result;
   }

   getErrorsTmp(): Boolean {
      if (!this.getChoicesTmp) {
         return false;
      }
      let _result = false;
      Object.keys(this.getChoicesTmp.controls).forEach(key1 => {
         const _tmp = this.getChoicesTmp.get(key1) as FormGroup;
         Object.keys(_tmp.controls).forEach(key2 => {
            const controlErrors: ValidationErrors | null = _tmp.get(key2)?.errors ?? null;
            if (controlErrors) {
               _result = true;
               return;
            }
         });
      });
      return _result;
   }

   markTouch() {
      if (!this.getChoices) {
         return;
      }
      Object.keys(this.getChoices.controls).forEach(key1 => {
         const _tmp = this.getChoices.get(key1) as FormGroup;
         Object.keys(_tmp.controls).forEach(key2 => {
            if (key2 === 'value') {
              _tmp.get(key2)?.updateValueAndValidity();
              _tmp.get(key2)?.markAsTouched();
            }

         });
      });
   }

   alertError(key: string) {
      if (!this.getChoices) {
         return null;
      }
      const _tm = this.getChoices.get(key.toString()) as FormGroup;
      return _tm;
   }

   _close() {
      this.dialog.closeAll();
   }

   drop(event: CdkDragDrop<string[]>) {
      if (!this.getChoices) {
         return;
      }
      moveItemInArray(this.getChoices.controls, event.previousIndex, event.currentIndex);
      this.getChoices.updateValueAndValidity();
   }

   lookupOpen() {
      const data = { state: this.state, eForm: this.eForm , choice: this.newControl.getInitChoice,
                     defaultValue: 1, field: this.getAllField };
      const dialog = this.dialog.open(ChoiceLookupComponent, { disableClose: true, data });
      dialog.afterOpened().subscribe(() => this.sendFocus.emit(false));
      dialog.afterClosed().subscribe(() => {
               this.sendFocus.emit(true);
               this.markTouch();
               this.getErrors();
               this.markAll();
         });
   }

   setupOpen() {
      const data = { state: this.state, eForm: this.eForm , choice: this.getChoices,
                     defaultValue: this._getValue('choiceDefaultValue'), field: this.getAllField };
      const dialog = this.dialog.open(ChoiceSetupComponent, { disableClose: true, data });
      dialog.afterOpened().subscribe(() => this.sendFocus.emit(false));
      dialog.afterClosed().subscribe(() => {
               this.sendFocus.emit(true);
               this.markTouch();
               this.getErrors();
               this.markAll();
         });
   }

   invalidForm() {
      return this.getAllField ? this.getAllField.invalid : false;
   }

   markAll() {
      if (!this.getChoices) {
         return;
      }
      this.getChoices.controls.forEach(v => {
         const _lavel = v.get('label') as FormGroup;
         const _labelWithOriginal  = _lavel.controls[this.eForm.controls.original.value];
         _labelWithOriginal.updateValueAndValidity();
         _labelWithOriginal.markAsTouched();
      });
   }

    _setChoiceOption(value: number, type: string) {
      if (!this.currentFieldGroup) {
         return;
      }
      const targetControl = this.currentFieldGroup.get(type);
      if (!targetControl) {
         return;
      }

      if(this.table){
         targetControl.setValue(value);
         this.helper.getFieldTableAsFormArray(this.eForm, this.state.sectionIndex, this.state.tableIndex).updateValueAndValidity();
      }else{
         targetControl.setValue(value);
         this.helper.getFieldAsFormArray(this.eForm, this.state.sectionIndex).updateValueAndValidity();
      }

   }

   _getValue(type: string) {
      if (!this.currentFieldGroup) {
         return null;
      }
      if(this.table){
         return this.helper.getFieldTableSomeValue(this.eForm, type, this.state.sectionIndex, this.state.fieldIndex, this.state.tableIndex);
      }else{
         return this.helper.getFieldSomeValue(this.eForm, type, this.state.sectionIndex, this.state.fieldIndex);
      }

   }

   get getChoices() {
      if(this.table){
         return this.currentFieldGroup?.get('choices') as FormArray;
      }else{
         return this.currentFieldGroup?.get('choices') as FormArray;
      }

   }

   get getChoicesTmp() {
      if(this.table){
         return this.currentFieldGroup?.get('choiceTmp') as FormArray;
      }else{
         return this.currentFieldGroup?.get('choiceTmp') as FormArray;
      }

   }

   get getField() {
      if(this.table){
         return this.currentFieldGroup?.get('choiceLookUp') as FormGroup;
      }else{
         return this.currentFieldGroup?.get('choiceLookUp') as FormGroup;
      }

   }

   get getAllField() {
      if(this.table){
         return this.currentFieldGroup as FormGroup;
      }else{
         return this.currentFieldGroup as FormGroup;
      }

   }

   get currentFieldGroup(): FormGroup {
      if (this.table) {
         return this.helper.getFieldTableAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex, this.state.tableIndex) as FormGroup;
      }

      return this.helper.getFieldAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex) as FormGroup;
   }

}
